// extracted by mini-css-extract-plugin
var _1 = "ra-legal-agreement-separator";
export { _1 as "legalAgreementSeparatorCls" }
